//replaces widget-settings.component.ts

import { ReactIconButton } from "app/components/React/ReactIconButton/ReactIconButton";
import type { IWidget } from "app/components/widget/widget-types/Widget";
import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import { i18nFilter } from "app/filters/i18nFilter";
import type { FC } from "react";
import { useState } from "react";
import { SwTrack } from "app/services/SwTrack";
import styled from "styled-components";

const cssClass = "swWidgetCog-popupItem";
const OpenMenuBtn = styled.div`
    position: absolute;
    top: 0;
    right: 0;
`;
const MenuList = styled.ul`
    position: absolute;
    top: 45px;
    background-color: #f5f9fd;
    z-index: 9;
    right: 0;
    transition:
        background-color 200ms,
        box-shadow 200ms ease 0ms,
        opacity 250ms;
    min-width: 125px;
    width: max-content;
    padding: 4px 0;
    font-weight: 400;
    font-size: 15px;
    font-size: 0.9375rem;
    text-align: left;
    box-sizing: border-box;
    box-shadow: 0 1px 2px 1px rgb(0 0 0 / 13%);
`;

const DropdownContainerMenu = styled.div`
    .icon-arrow {
        display: none;
    }
    .DropdownButton {
        border: none;
        background: transparent;
        .DropdownButton-text {
            text-indent: 0px;
            width: 100%;
        }

        &:hover {
            border: none;
            box-shadow: none;
        }
        &.DropdownButton--opened {
            box-shadow: none;
        }
    }
`;
const onToggle = () => {
    SwTrack.all.trackEvent("Drop down", "open", "Widget Settings");
};

interface IWidgetMenu extends IDashboardWidgetInterface {
    onEdit(widget: IWidget<any>): void;
    onDelete(widget: IWidget<any>): void;
    onDuplicate(widget: IWidget<any>): void;
}

export const WidgetMenu: FC<IWidgetMenu> = (props) => {
    const { widget, onEdit, onDelete, onDuplicate } = props;
    const [deletePopUpIsOpen, setDeletePopUpIsOpen] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const isDeprecated = widget._metricConfig.isDeprecated;

    function handleMenuClick() {
        setShowMenu(!showMenu);
    }
    const triggerAction = (e) => {
        const action = e.target.attributes.getNamedItem("data-menuid").value;
        SwTrack.all.trackEvent("Drop Down", "click", `Widget Settings/${action}`);
        switch (action) {
            case "duplicate":
                onDuplicate(widget);
                setShowMenu(!showMenu);

                break;
            case "delete":
                // todo: instead of mutating widget.delete,send its function as parameter once Events handling mechanism is in place
                onDelete(widget);
                setShowMenu(!showMenu);

                //widget.delete = () => {

                // };
                // todo: change once eventEmitter mechanism is in place
                // $scope.$emit("widget.showDialog", "delete");
                break;
            case "edit":
                onEdit(widget);
                setShowMenu(!showMenu);
                break;
        }
        setDeletePopUpIsOpen(!deletePopUpIsOpen);
    };

    const menuItems = [
        !isDeprecated && { id: "edit", text: i18nFilter()("home.dashboards.widget.menu.edit"), cssClass },
        !isDeprecated && { id: "duplicate", text: i18nFilter()("home.dashboards.widget.menu.duplicate"), cssClass },
        {
            id: "delete",
            text: i18nFilter()("home.dashboards.widget.menu.delete"),
            cssClass: `${cssClass} ${!isDeprecated && "swDropdownMenu-topDivider"}`,
        },
    ].filter(Boolean);

    return (
        <DropdownContainerMenu>
            <OpenMenuBtn onClick={handleMenuClick}>
                <ReactIconButton iconName="settings" />
            </OpenMenuBtn>
            {showMenu ? (
                <MenuList>
                    {menuItems.map((item) => {
                        return (
                            <li key={item.id}>
                                <a
                                    data-menuid={item.id}
                                    onClick={triggerAction}
                                    className={`swWidgetCog-popupItem ${item.cssClass}`}
                                >
                                    {item.text}
                                </a>
                            </li>
                        );
                    })}
                </MenuList>
            ) : null}
        </DropdownContainerMenu>
    );
};
